/*! MakNorte Shuffle - embaralha só "Mais Vendidos" na home */
(function(){
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;
  function mulberry32(s){return function(){s|=0;s=s+0x6D2B79F5|0;let t=Math.imul(s^s>>>15,1|s);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296;};}
  function shuffle(a,rng){a=a.slice();for(let i=a.length-1;i>0;i--){const j=Math.floor(rng()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;}
  function run(){
    const s=document.querySelector('[id*="product_list_fa"]');
    if(!s)return;
    const rng=mulberry32(Date.now());
    const list=s.querySelector('[class*="product-list"], .product-grid, resource-list');
    if(!list)return;
    const cards=Array.from(list.children).filter(el=>el.querySelector('product-card')||el.tagName.toLowerCase()==='product-card');
    if(cards.length<2)return;
    const sh=shuffle(cards,rng);
    const frag=document.createDocumentFragment();
    sh.forEach(c=>frag.appendChild(c));
    list.appendChild(frag);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
